"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolSyncExpiredError extends client_library_1.ExtendableError {
    constructor() {
        super('Your school sync has expired');
    }
}
exports.default = SchoolSyncExpiredError;
//# sourceMappingURL=SchoolSyncExpiredError.js.map